export var REMOTE_DESKTOP_EXERCISE = 'RemoteDesktopExercise';
export var EXPORTED_EXERCISES = [REMOTE_DESKTOP_EXERCISE];